var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"top",staticClass:"relative"},[_c('client-only',_vm._l((_vm.lanternImages),function(lantern,index){return _c('img',{key:index,staticClass:"absolute top-0 left-0",style:({
        transform: _vm.cssTransformation(index)
      }),attrs:{"src":lantern,"alt":""}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }